export default {
  formId: 'editNovedadTurnoForm', //'editNovedadTurnoForm',
  formField: {
   
    
    e_colaborador: {
      name: 'e_colaborador',
      label: 'Colaborador*',
      requiredErrorMsg: 'Colaborador  es requerido.'
    },
    e_responsable: {
      name: 'e_responsable',
      label: 'Responsable*',
      requiredErrorMsg: 'Responsable  es requerido.'
    },
    e_tipoNovedad: {
      name: 'e_tipoNovedad',
      label: 'Tipo Novedad*',
      requiredErrorMsg: 'Tipo Novedad  es requerido.'
    },
    e_fechaNovedad: {
      name: 'e_fechaNovedad',
      label: 'Fecha Novedad*',
      requiredErrorMsg: 'Fecha Novedad  es requerido.'
    },
    e_horaNovedad: {
      name: 'e_horaNovedad',
      label: 'Hora Novedad*',
      requiredErrorMsg: 'Hora Novedad  es requerido.'
    },
    e_description: {
      name: 'e_description',
      label: 'Descripcion*',
      requiredErrorMsg: 'Descripcion es requerido.'
    }

  }
};
